import { FC, useContext } from "react";
import { Modal } from "react-bootstrap";

import { NewVersionContext} from "../../../context/newVersionContext";


const NewVersionModal: FC = (): JSX.Element => {
    const { isVersionModalVisible, changeVersionAlert } = useContext(NewVersionContext)

    return (
        <Modal
            show={isVersionModalVisible}
            style={{ backdropFilter:"brightness(0.3)", WebkitBackdropFilter:"brightness(0.3)" }}
            size="lg"
            aria-labelledby="important-notice-modal-title"
            centered
            onHide={() => changeVersionAlert(!isVersionModalVisible)}
            // onBackdropClick={(e) => { e.stopPropagation(); changeVersionAlert(!isVersionModalVisible)}}
            contentClassName="show-modal-content"
        >
            <Modal.Body>
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="text-center">
                            <i className="bi bi-exclamation-circle-fill text-warning fs-1"></i>
                        </div>
                        <h3 className="text-center">Change Alert</h3>
                        <p className="text-center fs-6">
                            A new version is released. Please click on OK button to get the latest version.
                        </p>
                    </div>
                    <div className="col-12 text-center">
                        <button
                            type="button"
                            className="btn btn-primary btn-lg px-5"
                            data-bs-dismiss="modal"
                            onClick={() => changeVersionAlert(false)}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default NewVersionModal
